var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5077 5.69793C20.8126 5.9783 20.8325 6.45275 20.5521 6.75766L10.0371 18.1928C9.65695 18.6062 8.99912 18.602 8.6246 18.1824L3.44045 12.3737C3.16464 12.0647 3.19158 11.5906 3.50061 11.3147C3.80965 11.0389 4.28375 11.0659 4.55956 11.3749L9.34164 16.7331L19.4479 5.74235C19.7283 5.43745 20.2028 5.41756 20.5077 5.69793Z",
    fill: "#282930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark2);
export default __webpack_public_path__ + "static/media/checkmark2.e334898a99218c17f431130e32675ecc.svg";
export { ForwardRef as ReactComponent };